export const local = {
  get(key) {
    try {
      const storedValue = typeof window !== 'undefined' ? window.localStorage.getItem(key) : null
      return JSON.parse(storedValue)
    } catch (e) {
      console.error(e)
      return false
    }
  },
  set(key, value = undefined) {
    try {
      if (!value) {
        window.localStorage.removeItem(key)
        return
      }
      if (value) {
        value = JSON.stringify(value)
      }

      if (typeof window !== 'undefined') {
        window.localStorage.setItem(key, value)
      }
    } catch (e) {
      console.error(e)
      return false
    }
  }
}
